var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsbDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 160V352C0 387.346 28.654 416 64 416H448V96H64C28.654 96 0 124.652 0 160ZM608 128H480V384H608C625.674 384 640 369.672 640 352V160C640 142.326 625.674 128 608 128ZM584 312C584 320.875 576.875 328 568 328H552C543.125 328 536 320.875 536 312V296C536 287.125 543.125 280 552 280H568C576.875 280 584 287.125 584 296V312ZM584 216C584 224.875 576.875 232 568 232H552C543.125 232 536 224.875 536 216V200C536 191.125 543.125 184 552 184H568C576.875 184 584 191.125 584 200V216Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsbDrive);
export default __webpack_public_path__ + "static/media/usb-drive.e5fd74beb402050b65537f04ea2d2a5f.svg";
export { ForwardRef as ReactComponent };